import React from 'react';

const TermsAndConditionsRu = () => {
    return (
        <>
            <h1>Договор оферта</h1>
            <p>
                Индивидуальный предприниматель Нуриев Олег Николаевич (ИНН 317723310075635), именуемый в дальнейшем
                Правообладатель, зарегистрированный в Едином государственном реестре индивидуальных предпринимателей под
                №317723310075635, адресует настоящий лицензионный договор (далее по тексту - Договор) любому лицу
                (неопределенному кругу лиц), выразившему готовность заключить лицензионный договор о предоставлении
                права использования Объекта интеллектуальной собственности Пользователь).
            </p>

            <p>
                Договор, согласно п. 2 ст. 437 Гражданского кодекса Российской Федерации, является публичной офертой,
                принятием условий (акцептом) которой является совершение действий, предусмотренных Договором.
            </p>

            <p>
                <strong>1. Определения</strong>
            </p>

            <p>
                1.1. Условия Договора регулируют отношения Правообладателя и Пользователя и содержат следующие
                определения:
            </p>

            <p>
                1.1.1. Оферта — настоящий документ (Договор), размещенный в сети Интернет по адресу:
                <a href="https://connect-api.com">https://connect-api.com</a> (далее - Сайт). В соответствии с
                Договором, слова оферта и Договор являются равнозначными.
            </p>

            <p>
                1.1.2. Акцепт — полное и безоговорочное принятие оферты путем осуществления действий, указанных в п. 3.1
                Договора.
            </p>

            <p>
                1.1.3. Правообладатель — индивидуальный предприниматель (Нуриев Олег Николаевич), разместивший(ая)
                оферту.
            </p>

            <p>
                1.1.4. Пользователь — юридическое или физическое лицо, заключившее Договор посредством акцепта на
                условиях, содержащихся в оферте.
            </p>

            <p>1.1.5. Объект интеллектуальной собственности — Программа для ЭВМ - «Api мессенджера ConnectApi».</p>

            <p>
                1.1.6. Простая (неисключительная) лицензия — неисключительное право Пользователя использовать Объект
                интеллектуальной собственности с сохранением за Правообладателем права выдачи лицензий другим лицам.
            </p>

            <p>
                1.1.7. Личный кабинет — это виртуальный инструмент персонального самообслуживания Правообладателя,
                расположенный на официальном интернет - сайте{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>

            <p>
                1.1.8. Учетная запись — содержащаяся на Сайте запись электронного реестра, которая относится к
                Пользователю (и только к нему) и содержит данные о Пользователе и его действиях на Сайте, в том числе
                идентификационные данные для Авторизации.
            </p>

            <p>
                1.1.9. Авторизация — процесс анализа введенных Пользователем идентификационных данных, по результатам
                которого определяется наличие у него права на использование Объекта интеллектуальной собственности.
                Идентификационные данные для доступа к Объекту интеллектуальной собственности определены необходимыми и
                достаточными в виде пароля и логина (далее «Пароль» и «Логин»).
            </p>

            <p>
                1.2. В Договоре могут быть использованы термины, не определенные вышеперечисленными понятиями. В этом
                случае, толкование такого термина производится в соответствии с текстом Договора. В случае отсутствия
                однозначного толкования термина в тексте Договора Стороны руководствуются толкованием термина: в первую
                очередь - определенным на сайте:
                <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>

            <p>
                <strong>2. Предмет договора</strong>
            </p>

            <p>
                2.1. По Договору Правообладатель предоставляет (передает) Пользователю право использования программы для
                ЭВМ - «Api мессенджера ConnectApi» (далее по тексту – Объект интеллектуальной собственности),
                характеристики которой указаны в Описании Программы, находящемся по адресу:{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>, на условиях простой (неисключительной)
                лицензии, а Пользователь приобретает право использования Объекта интеллектуальной собственности в
                порядке и на условиях, установленных Договором.
            </p>

            <p>
                2.2. Правообладатель гарантирует, что он является правообладателем исключительных прав на Объект
                интеллектуальной собственности, указанный в п. 2.1 Договора.
            </p>

            <p>
                2.3. Срок предоставления права использования Объекта интеллектуальной собственности устанавливается на
                весь период действия исключительных прав на Объекта интеллектуальной собственности.
            </p>

            <p>
                2.4. Использование Объекта интеллектуальной собственности Пользователем территорией не ограничено (весь
                мир), в порядке и на условиях, предусмотренных действующим законодательством Российской Федерации и
                настоящим Договором.
            </p>

            <p>
                2.5. Стоимость доступа к Объекту интеллектуальной собственности и к ее компонентам для одного
                пользователя определяется Прейскурантом Правообладателя (Приложение №1 к Договору), расположенном в
                разделе «Тарифы» в сети Интернет по адресу:
                <a href="https://connect-api.com/price">https://connect-api.com/price</a>.
            </p>

            <p>
                2.6. При появлении новых функций в системе, Правообладатель по своему усмотрению имеет право требовать
                дополнительную оплату за их использование.
            </p>

            <p>
                <strong>3. Порядок заключения договора</strong>
            </p>

            <p>
                3.1. Акцептом Договора является регистрация личного кабинета Правообладателя или оплата доступа к
                Объекту интеллектуальной собственности и к ее компонентам, согласно Прейскуранту&nbsp;Правообладателя
                (Приложение №1 к Договору), расположенном в разделе «Тарифы» в сети Интернет по адресу:{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>

            <p>
                3.2. Осуществляя акцепт Договора в порядке, определенном п. 3.1 Договора, Правообладатель гарантирует,
                что ознакомлен, соглашается, полностью и безоговорочно принимает все условия Договора.
            </p>

            <p>
                3.3. Договор может быть принят Пользователем исключительно в целом (п. 1 ст. 428 Гражданского кодекса
                Российской Федерации).
            </p>

            <p>
                3.4. Настоящим Пользователь подтверждает, что акцепт Договора равносилен заключению Договора на
                условиях, изложенных в Договоре.
            </p>

            <p>
                3.5. Оферта вступает в силу с момента размещения в сети Интернет по адресу{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>и действует до момента отзыва оферты.
            </p>

            <p>3.6. Настоящий Договор размещен в электронном виде на Сайте.</p>

            <p>
                3.7. После ознакомления и принятия Пользователем условий настоящего Договора Пользователь осуществляет
                регистрацию путем создания Учётной записи на Сайте. Дальнейшее использование Объекта интеллектуальной
                собственности возможно только по завершении Авторизации Пользователя.
            </p>

            <p>
                3.8. Для организации взаимодействия между Правообладателем и Пользователем, Пользователь самостоятельно
                регистрирует Личный кабинет в следующем порядке:
            </p>

            <p>а) перейти в раздел «Регистрация»;</p>

            <p>б) заполнить данные регистрации: телефон, email, придумать пароль;</p>

            <p>в) принять условия, нажать кнопку «Зарегистрироваться»;</p>

            <p>г) получить смс для подтверждения Логина (телефона);</p>

            <p>д) пройти процедуру Авторизации.</p>

            <p>3.9. Для регистрации Пользователь обязуется предоставить достоверную и полную информацию о себе.</p>

            <p>
                3.10. В Личном кабинете Пользователя указывается следующая информация о Пользователе: Email, Телефон,
                ФИО.
            </p>

            <p>
                3.11. Пользователь самостоятельно несет ответственность за безопасность своих данных, а также
                самостоятельно обеспечивает конфиденциальность своего пароля. Пользователь самостоятельно несет
                ответственность за все действия/бездействие (а также их последствия) в рамках или с использованием
                Объекта интеллектуальной собственности под своей Учетной записью, включая случаи добровольной передачи
                или несоблюдения конфиденциальности данных для доступа к его учетной записи третьим лицам на любых
                условиях (в том числе по соглашениям или договорам). При этом все действия в рамках или с использованием
                Объекта интеллектуальной собственности под учетной записью Пользователя считаются произведенными им
                самим, за исключением случаев, имеющих место после получения Правообладателем от Пользователя
                направленного в порядке, предусмотренном настоящим Договором, уведомления о несанкционированном
                использовании Объекта интеллектуальной собственности под учетной записью Пользователя или о любом
                нарушении (подозрениях о нарушении) конфиденциальности своего пароля.
            </p>

            <p>
                3.12. Пользователь обязан немедленно уведомить Правообладателя о любом случае несанкционированного
                доступа к Объекту интеллектуальной собственности с использованием его Учетной записи и/или о любом
                нарушении (подозрениях о нарушении) конфиденциальности своего пароля. В целях безопасности, Пользователь
                обязан самостоятельно осуществлять безопасное завершение работы под своей учетной записью (кнопка
                «Выйти») по окончании каждой сессии работы с Программой для ЭВМ - «Api мессенджера ConnectApi».
                Правообладатель не отвечает за возможную потерю данных, а также другие последствия любого характера,
                которые могут произойти из-за нарушения Пользователем положений этой части Договора.
            </p>

            <p>
                3.13. Удаление Учетной записи. Правообладатель вправе заблокировать и удалить Учетную запись
                Пользователя, включая все связанные данные без объяснения причин, в случае нарушения условий Договора,
                действий способных принести вред системе или репутации компании (Раздел 4). С этого момента
                восстановление учетной записи, какой-либо информации, относящейся к ней, а равно доступов к Объекту
                интеллектуальной собственности с использованием этой Учетной записи — невозможны.
            </p>

            <p>
                <strong>4. Права и обязанности сторон</strong>
            </p>

            <p>4.1. Правообладатель обязуется:</p>

            <p>
                4.1.1. Воздерживаться от каких-либо действий, способных затруднить осуществление Пользователем
                предоставленного ему права использования Объекта интеллектуальной собственности в установленных
                Договором пределах.
            </p>

            <p>
                4.1.2. Предоставлять право использования программы для ЭВМ или базы данных ежедневно и круглосуточно, за
                исключением времени проведения профилактических мероприятий, составляющих не более 24 часов в месяц.
            </p>

            <p>
                4.1.3. Предоставлять информацию по вопросам работы с программой для ЭВМ или базы данных посредством
                электронной почты, информации на сайте. Актуальные адреса электронной почты находятся в разделе
                «Поддержка» предоставленной программы и на официальном сайте по адресу:{' '}
                <a href="https://connect-api.com/support">https://connect-api.com/support</a>.
            </p>

            <p>
                4.1.4. Предоставлять информацию об обновлениях текущей версии программы или базы данных, вышедших в
                течение срока действия Договора.
            </p>

            <p>
                4.1.5. При наличии технической возможности устранять возможные программные сбои в работе программы или
                базы данных, возникшие по вине Правообладателя, на основании заявки Пользователя, за исключением случаев
                нарушения Пользователем Правил эксплуатации программы/базы данных.
            </p>

            <p>
                4.1.6. Использовать все личные данные и иную конфиденциальную информацию о Пользователе только для
                оказания услуг по Договору, не передавать третьим лицам находящуюся у него документацию и информацию о
                Пользователе.
            </p>

            <p>
                4.1.7. Обеспечивать конфиденциальность информации, введенной Пользователем при использовании Сайта через
                личную учетную запись Пользователя, за исключением случаев размещения такой информации в общедоступных
                разделах Сайта (например, чат).
            </p>

            <p>4.1.8. Оказывать следующие дополнительные услуги по Договору:</p>

            <p>
                4.1.8.1. Производить обучение Пользователя правилам и порядку работы с программой для ЭВМ или базой
                данных.
            </p>

            <p>
                4.1.8.2. Осуществлять техническую поддержку и информационное сопровождение программы для ЭВМ и базы
                данных.
            </p>

            <p>
                4.1.9. Консультировать Пользователя по всем вопросам, касающимся Объекта интеллектуальной собственности.
                Сложность вопроса, объем, и сроки консультирования определяются в каждом конкретном случае
                Правообладателем самостоятельно.
            </p>

            <p>4.2. Пользователь обязуется:</p>

            <p>
                4.2.1. Использовать Объект интеллектуальной собственности только в пределах тех прав и теми способами,
                которые предусмотрены в Договоре.
            </p>

            <p>4.2.2. Осуществлять оплату по Договору в соответствии с условиями настоящего Договора.</p>

            <p>
                4.2.3. Хранить в тайне и не раскрывать третьим лицам информацию о своем пароле, дающем доступ в Личный
                кабинет Пользователя. В случае, если такая информация по тем или иным причинам станет известна третьим
                лицам, Пользователь обязуется немедленно изменить и немедленно уведомить Правообладателя о любом случае
                несанкционированного доступа.
            </p>

            <p>
                4.2.4. Строго придерживаться и не нарушать условий Договора, а также обеспечить конфиденциальность
                полученной при сотрудничестве с Правообладателем коммерческой и технической информации.
            </p>

            <p>
                4.2.5. Воздерживаться от копирования в любой форме, а также от изменения, дополнения, распространения
                (включая публичную демонстрацию Объекта интеллектуальной собственности (либо любой его части), а также
                воздерживаться от создания на его (ее) основе производных объектов без предварительного письменного
                разрешения Правообладателя. Все исключительные права на Объект интеллектуальной собственности
                неотчуждаемы и остаются у Правообладателя в полном объеме.
            </p>

            <p>
                4.2.6. Не использовать никаких приборов либо компьютерных программ для вмешательства или попытки
                вмешательства в процесс нормального функционирования Сайта Правообладателя.
            </p>

            <p>
                4.2.7. Незамедлительно информировать Правообладателя обо всех ставших ему известных фактах
                противоправного использования третьими лицами Объекта интеллектуальной собственности.
            </p>

            <p>4.2.8. Исполнять иные обязанности, предусмотренные Договором.</p>

            <p>4.3. Правообладатель вправе:</p>

            <p>
                4.3.1. Приостановить, прекратить регистрацию и доступ Пользователя на Сайт или удалить Учетную запись,
                если Правообладатель будет обоснованно считать, что Пользователь ведет неправомерную деятельность.
            </p>

            <p>
                4.3.2. Обобщать и анализировать полученные данные о работе с программой/базой данных и о конкретных
                действиях Пользователя на условиях конфиденциальности и анонимности в статистических и маркетинговых
                целях. При составлении каких-либо статистических или маркетинговых отчетов, публикации каких-либо
                статистических или маркетинговых данных, полученных путем такого обобщения и анализа, Правообладатель не
                вправе указывать конкретные наименования и (или) адреса, а равно прочие сведения, которые позволяют
                установить связь с тем или иным Пользователем.
            </p>

            <p>4.3.3. Требовать выплаты вознаграждения в порядке и сроки, установленные Договором.</p>

            <p>
                4.3.4. В случае нарушения Пользователем условий (способов) использования прав на Объект интеллектуальной
                собственности по Договору, лишить Пользователя права использования Объекта интеллектуальной
                собственности. Нарушение норм об охране авторских прав может также повлечь гражданско-правовую и
                уголовную ответственность в соответствии с законодательством РФ.
            </p>

            <p>
                4.3.5. Расторгнуть Договор и отказать в предоставлении Пользователю прав использования Объекта
                интеллектуальной собственности в случае нарушения Пользователем сроков оплаты, либо по другим
                основаниям, предусмотренным Договором.
            </p>

            <p>4.3.6. Вносить в одностороннем порядке изменения в Договор путем издания новых редакций Договора.</p>

            <p>4.4. Пользователь вправе:</p>

            <p>
                4.4.1. После получения Объекта интеллектуальной собственности, в соответствии с условиями Договора,
                использовать Объект интеллектуальной собственности в объеме и порядке, установленном в Договоре.
            </p>

            <p>
                4.4.2. Отказаться от исполнения Договора, если Правообладатель в нарушение условий Договора отказывается
                передать Пользователю право использования Объекта интеллектуальной собственности по Договору.
            </p>

            <p>
                4.4.3. Использовать Объект интеллектуальной собственности, исключая любые случаи перепродажи, аренды или
                передачи Объекта интеллектуальной собственности третьим лицам, возможных только после заключения
                соответствующих письменных соглашений с Правообладателем.
            </p>

            <p>
                <strong>5. Предоставление права использования</strong>
            </p>

            <p>
                5.1. Пользователю предоставляется простая (неисключительная) лицензия на использование Объекта
                интеллектуальной собственности в объеме и порядке, установленном Договором.
            </p>

            <p>
                5.2. Срок предоставления права использования Объекта интеллектуальной собственности устанавливается на
                весь период действия исключительных прав на Объекта интеллектуальной собственности.
            </p>

            <p>
                5.3. По Договору Правообладатель предоставляет Пользователю право использования Объекта интеллектуальной
                собственности на условиях простой (неисключительной) лицензии, следующими способами:
            </p>

            <p>
                5.3.1. Публичный показ Объекта интеллектуальной собственности, то есть любая демонстрация оригинала или
                экземпляра произведения непосредственно либо на экране с помощью пленки, диапозитива, телевизионного
                кадра или иных технических средств, а также демонстрация отдельных кадров аудиовизуального произведения
                без соблюдения их последовательности непосредственно либо с помощью технических средств в месте,
                открытом для свободного посещения, или в месте, где присутствует значительное число лиц, не
                принадлежащих к обычному кругу семьи, независимо от того, воспринимается произведение в месте его
                демонстрации или в другом месте одновременно с демонстрацией произведения в неограниченном объеме.
            </p>

            <p>
                <strong>6. Размер вознаграждения</strong>
            </p>

            <p>
                6.1. Размер вознаграждения по Договору указывается в Прейскуранте (Приложение №1 к Договору),
                расположенном в разделе «Тарифы» в сети Интернет по адресу{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>

            <p>
                6.2. Правообладатель вправе в любое время в одностороннем порядке изменить размер вознаграждения по
                Договору. Указанные условия вступают в силу с момента их размещения, способом, установленном для
                размещения оферты.
            </p>

            <p>
                6.3. Способ оплаты по Договору: перечисление Пользователем денежных средств в валюте Российской
                Федерации (рубль) на расчетный счет Правообладателя или способами, указанными в разделе «Тарифы» в сети
                Интернет по адресу
                <a href="https://connect-api.com">https://connect-api.com</a>. При этом обязанности Пользователя в части
                оплаты по Договору считаются исполненными со дня зачисления денежных средств на расчетный счет
                Правообладателя.
            </p>

            <p>
                <strong>7. Персональные данные</strong>
            </p>

            <p>
                7.1. Для выполнения условий Договора Пользователь соглашается предоставить и дает согласие на обработку
                персональных данных в соответствии с Федеральным законом от 27.07.2006 года №152-ФЗ «О персональных
                данных» на условиях и для целей надлежащего исполнения Договора. Под «персональными данными» понимается
                персональная информация, которую Пользователь предоставляет о себе самостоятельно для совершения
                акцепта.
            </p>

            <p>
                7.2. Правообладатель гарантирует конфиденциальность в отношении персональных данных Пользователя и
                предоставляет доступ к персональным данным только тем сотрудникам, которым эта информация необходима для
                выполнения условий Договора, обеспечивая соблюдение указанными лицами конфиденциальности персональных
                данных и безопасности персональных данных при их обработке.
            </p>

            <p>
                7.3. В случаях утери Пользователем идентификационных данных для доступа к личному кабинету, Пользователь
                вправе запросить данные сведения у Правообладателя, посредством направления запроса через электронную
                почту Правообладателя.
            </p>

            <p>
                7.4. Полученная Правообладателем информация (персональные данные) не подлежит разглашению, за
                исключением случаев, когда ее раскрытие является обязательным по законодательству Российской Федерации
                или необходимо для работы Сайта и его функций.
            </p>

            <p>
                <strong>8. Ответственность сторон</strong>
            </p>

            <p>
                8.1. Стороны несут ответственность за неисполнение или ненадлежащее исполнение своих обязательств по
                Договору в соответствии с законодательством России.
            </p>

            <p>
                8.2. Правообладатель не принимает на себя ответственность за соответствие Объекта интеллектуальной
                собственности целям использования.
            </p>

            <p>
                8.3. Правообладатель не несет ответственности за технические перебои в работе оборудования и
                программного обеспечения. Вместе с тем Правообладатель обязуется принимать все разумные меры для
                предотвращения таких перебоев.
            </p>

            <p>
                8.4. Использование Объекта интеллектуальной собственности способом, не предусмотренным Договором, либо
                по прекращении действия Договора, либо иным образом за пределами прав, предоставленных Пользователю по
                Договору, влечет установленную законодательством ответственность за нарушение исключительного права на
                Объект интеллектуальной собственности.
            </p>

            <p>
                8.5. Правообладатель не несет ответственности за любые действия Пользователя, связанные с использованием
                предоставленных прав использования Объекта интеллектуальной собственности; за ущерб любого рода,
                понесенный Пользователем из-за утери и/или разглашения своих данных либо в процессе использования
                Объекта интеллектуальной собственности.
            </p>

            <p>
                8.6. Правообладатель не несет ответственности и не возмещает убытки Пользователя, вызванные нарушениями
                и/или ошибками при эксплуатации Объекта интеллектуальной собственности, возникшие в результате
                неправомерных действий Пользователя, его персонала, либо третьих лиц.
            </p>

            <p>
                8.7. В случае если какое-либо третье лицо предъявляет Правообладателю претензию в связи с нарушением
                Пользователем Договора либо действующих законодательных норм, нарушением Пользователем прав третьих лиц
                (в том числе прав на интеллектуальную собственность), Пользователь обязуется компенсировать
                Правообладателю все расходы и потери, в том числе оплатить любые компенсации и прочие затраты, связанные
                с такой претензией.
            </p>

            <p>
                <strong>9. Основания и порядок изменения и расторжения договора</strong>
            </p>

            <p>
                9.1. Правообладатель вправе в любое время в одностороннем (внесудебном) порядке внести изменения в
                условия Договора. Изменения в условия Договора вступают в силу с момента их размещения, способом,
                установленном для размещения оферты.
            </p>

            <p>
                9.2. Договор может быть расторгнут по соглашению Сторон, а также в одностороннем порядке по письменному
                требованию одной из Сторон по основаниям, предусмотренным Договором и законодательством.
            </p>

            <p>
                9.3. Расторжение Договора в одностороннем порядке возможно в любое время по письменному требованию
                каждой из Сторон в течение 10 календарных дней со дня получения Стороной такого требования. Уведомление
                об одностороннем отказе от Договора направляется в письменной форме.
            </p>

            <p>
                9.4. После расторжения Договора все права использования Объекта интеллектуальной собственности будут
                аннулированы. Пользователь обязуется незамедлительно прекратить любое использование Объекта
                интеллектуальной собственности.
            </p>

            <p>
                <strong>10. Разрешение споров из договора</strong>
            </p>

            <p>
                10.1. Претензионный порядок досудебного урегулирования споров из Договора является для Сторон
                обязательным.
            </p>

            <p>
                10.2. Допускается направление Сторонами претензионных писем иными способами: электронная почта, форма
                обратной связи на сайте расположенная в сети Интернет по адресу{' '}
                <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>

            <p>
                10.3. Срок рассмотрения претензионного письма составляет 10 рабочих дней со дня получения последнего
                адресатом.
            </p>

            <p>10.4. Споры из Договора разрешаются в судебном порядке в соответствии с законодательством.</p>

            <p>
                <strong>11. Обстоятельства непреодолимой силы</strong>
            </p>

            <p>
                11.1. Стороны освобождаются от ответственности за полное или частичное неисполнение обязательств по
                Договору в случае, если неисполнение обязательств явилось следствием действий непреодолимой силы, а
                именно: пожара, наводнения, землетрясения, забастовки, войны, действий органов государственной власти
                или других независящих от Сторон обстоятельств.
            </p>

            <p>
                11.2. Сторона, которая не может выполнить обязательства по Договору, должна своевременно, но не позднее
                10 календарных дней после наступления обстоятельств непреодолимой силы, письменно известить другую
                Сторону, с предоставлением обосновывающих документов, выданных компетентными органами.
            </p>

            <p>11.3. Стороны признают, что неплатежеспособность Сторон не является форс-мажорным обстоятельством.</p>

            <p>
                <strong>12. Прочие условия</strong>
            </p>

            <p>
                12.1. Стороны не имеют никаких сопутствующих устных договоренностей. Содержание текста Договора
                полностью соответствует действительному волеизъявлению Сторон.
            </p>

            <p>
                12.2. Стороны признают, что если какое-либо из положений Договора становится недействительным в течение
                срока его действия вследствие изменения законодательства, остальные положения Договора обязательны для
                Сторон в течение срока действия Договора.
            </p>

            <p>
                <strong>13. Контактная информация</strong>
            </p>

            <p>
                Обращения по вопросам условий настоящего Договора принимаются по адресу электронной почты
                <a href="mailto:info@connect-api.com">info@connect-api.com</a> или через форму обратной связи на сайте
                расположенной в сети Интернет по адресу <a href="https://connect-api.com">https://connect-api.com</a>.
            </p>
        </>
    );
};

export default React.memo(TermsAndConditionsRu);
